<template>
  <div>
    <div class="head">
      <el-button size="small" type="primary" @click="addBtn">新增</el-button>
    </div>
    <div class="content">
      <el-table
      :data="tableData"
      :header-cell-style="{ fontWeight: 500, color: 'rgb(0,0,0,0.85)', background: '#fafafa' }"
      style="width: 100%">
        <el-table-column prop="name" label="队伍名称"></el-table-column>
        <el-table-column prop="rankLevel" label="队伍级别"></el-table-column>
        <el-table-column prop="responsiblePersonName" label="队伍负责人"></el-table-column>
        <el-table-column prop="responsiblePersonDep" label="负责人部门"></el-table-column>
        <el-table-column prop="responsiblePersonCellphone" label="负责人手机"></el-table-column>
        <el-table-column prop="responsiblePersonTel" label="固定电话"></el-table-column>
        <el-table-column label="操作" width="150px">
          <template slot-scope="{ row }">
            <el-link :underline="false" type="primary" @click="editBtn(row)">编辑</el-link>
            <span style="padding: 0 8px; color: #e8e8e8">|</span>
            <el-link :underline="false" type="danger" @click="deleteBtn(row)">删除</el-link>
            <span style="padding: 0 8px; color: #e8e8e8">|</span>
            <el-link :underline="false" type="info" @click="detailBtn(row.id)">详情</el-link>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 15px; text-align: right">
        <Page :total='total' :page-size='limit' :current='curPage' @on-change='curPageChange' />
      </div>
    </div>

    <!-- 详情抽屉 -->
    <el-drawer :visible.sync="drawer" direction="rtl" :before-close="handleClose" size="60%">
      <span slot="title">
        <div style="margin-left: 1%">
          <span style="font-size: 20px">
            <b>队伍名称：{{drawerDetail.name}}</b>
          </span>
        </div>
        <!-- <div style="margin-top: 1%;margin-left: 1%">
          <el-row :gutter="20">
            <el-col :span="4">
              <div class="grid-content bg-purple">
                <b>队伍级别</b>
              </div>
              <div class="grid-content bg-purple" style="margin-top: 3%">
                <span>{{drawerDetail.rank}}</span>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="grid-content bg-purple">
                <b>队伍负责人</b>
              </div>
              <div class="grid-content bg-purple" style="margin-top: 3%">
                <span>{{drawerDetail.companyId}}</span>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="grid-content bg-purple">
                <b>创建时间</b>
              </div>
              <div class="grid-content bg-purple" style="margin-top: 3%">
                <span>{{drawerDetail.gmtCreate}}</span>
              </div>
            </el-col>
          </el-row>
        </div> -->
      </span>
      <div class="outBox">
        <div class="detailContentBox">
          <el-form :model="drawerDetail" size="small" label-width="200px" style="padding-top: 20px">
            <el-col :span="12">
              <el-form-item label="队伍级别：">
                {{ drawerDetail.name }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="队伍负责人：">
                {{ drawerDetail.responsiblePersonName }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="负责人部门：">
                {{ drawerDetail.responsiblePersonDep }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="负责人手机：">
                {{ drawerDetail.responsiblePersonCellphone }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="固定电话：">
                {{ drawerDetail.responsiblePersonTel }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="相关附件：">
                <el-link type="primary" @click="download(drawerDetail.fileUrl, drawerDetail.fileName)">
                  {{ drawerDetail.fileName }}
                </el-link>
              </el-form-item>
            </el-col>
            <el-col :span="20">
              <el-form-item label="队伍描述：">
                {{ drawerDetail.descride }}
              </el-form-item>
            </el-col>
          </el-form>
          <div style="margin-top: 30px;width: 80%; margin: auto">
            <el-table
            :data="drawerDetail.empList"
            :header-cell-style="{ textAlign: 'center' }"
            :cell-style="{ textAlign: 'center' }"
            max-height="500px"
            style="width: 100%">
              <el-table-column prop="" label="队伍成员">
                <el-table-column prop="empNo" label="人员工号" width="180" />
                <el-table-column prop="name" label="人员名称" width="180" />
                <el-table-column prop="sex" label="人员性别">
                  <template slot-scope="{ row }">
                    <span v-if="row.sex === 1">男</span>
                    <span v-else-if="row.sex === 2">女</span>
                    <span v-else>未知</span>
                  </template>
                </el-table-column>
                <el-table-column prop="phone" label="手机号码" />
                <el-table-column prop="jobName" label="职位" />
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { meetEmerRanksList, meetEmerRanksDelete, meetEmerRanksDetail } from '@/api/processManager'
import { downLoadDocument } from '@/api/downLoad'
export default {
  name: 'meetEmergencyRanks',
  data() {
    return {
      tableData: [],
      curPage: 1,
      total: 0,
      limit: 10,
      // 抽屉的数据
      drawerDetail: {},
      drawer: false
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      meetEmerRanksList({ limit: this.limit, curPage: this.curPage, isPage: 1 }).then(res => {
        this.tableData = res.body.data
        this.total = res.body.cum
      })
    },
    curPageChange(val) {
      this.curPage = val
      this.getData()
    },
    addBtn() {
      this.$router.push('AddMeetEmergencyRanks')
    },
    editBtn(row) {
      let obj = { ...row }
      for(let i in obj) {
        if(obj[i] === null || obj[i] === '' || obj[i] === 'null') {
          delete obj[i]
        }
      }
      this.$router.push({
        name: 'AddMeetEmergencyRanks',
        params: { key: obj }
      })
    },
    deleteBtn(row) {
      meetEmerRanksDelete(row.id).then(res => {
        this.$message.success('删除成功')
        this.getData()
      })
    },
    detailBtn(id) {
      meetEmerRanksDetail(id).then(res => {
        this.drawerDetail = res.body.data
        this.drawer = true
      })
    },
    // 关闭抽屉
    handleClose() {
      this.drawer = false
    },
    download(url, name) {
      downLoadDocument(url, name)
    }
  }
}
</script>

<style scoped>

</style>